import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import ShimmerSingleBox from "./ShimmerSingleBox";
import { useQuery } from "@tanstack/react-query";
import { getBannerAPI } from "./APIS";

function Banner() {
  const { isLoading, error, data } = useQuery({
    queryKey: ["data"],
    queryFn: getBannerAPI,
    refetchOnWindowFocus: false,
  });
  if (error) return <div>{error.message}</div>;
  return (
    <>
    <Carousel variant="dark" fade={true} interval={9000} pause={false} touch={true}>
      {isLoading && (
        <div className="products">
          {Array.from({ length: 1 }, (_, index) => (
            <ShimmerSingleBox key={index} CustomStyle={{ height: "1510px" }} />
          ))}
        </div>
      )}
      {data &&
        data.map((ban, i) => (
          <Carousel.Item key={i}>
            <Link to={ban.url} target="_blank">
              <picture>
                <source
                  media="(min-width:1024px)"
                  height="1080"
                  width="1920"
                  srcSet={`${process.env.REACT_APP_API_ROOT}/storage/app/public/banner/${ban.photo}`}
                />
                <source
                  media="(min-width:768px)"
                  height="800"
                  width="800"
                  srcSet={`${process.env.REACT_APP_API_ROOT}/storage/app/public/banner/${ban.tab_image}`}
                />
                <source
                  media="(min-width:465px)"
                  height="375"
                  width="375"
                  srcSet={`${process.env.REACT_APP_API_ROOT}/storage/app/public/banner/${ban.mobile_image}`}
                />
                <img
                  src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/banner/${ban.mobile_image}`}
                  height="375"
                  width="375"
                  alt="Lehanges Under 25K"
                  loading="lazy"
                />
              </picture>
              {ban.banner_text && (
                <div className={`animated banner-text animate__slideInUp ${ban.banner_position}`}>
                  <h2>{ban.banner_text} </h2>
                  <span>Shop Now</span>
                </div>                
              )}
              
            </Link>
          </Carousel.Item>
        ))}
    </Carousel>
    </>
  );
}

export default Banner;
